module.exports = __webpack_public_path__ + "img/borabora.315a41db.jpg";